import { Pipe, PipeTransform } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { createMap } from '@fi-shared/utils/create-map';

enum fiTerminationPeriodType {
    Monthly = 1,
    Yearly = 2,
}

export interface ITerminationPeriod {
    Id: fiTerminationPeriodType;
    TextId: string;
}

export const fiTerminationPeriodTypes: ITerminationPeriod[] = [
    {
        Id: fiTerminationPeriodType.Monthly,
        TextId: 'termination_period.monthly',
    },
    {
        Id: fiTerminationPeriodType.Yearly,
        TextId: 'termination_period.yearly',
    },
];

function fiTerminationPeriodTypeName(terminationPeriodType: fiTerminationPeriodType, appText: AppTextService) {
    if (fiTerminationPeriodTypesMap.hasOwnProperty(terminationPeriodType))
        return appText.get(fiTerminationPeriodTypesMap[terminationPeriodType].TextId);

    throw 'FI: unknown termination period: ' + terminationPeriodType;
}

const fiTerminationPeriodTypesMap = createMap(fiTerminationPeriodTypes, 'Id');

@Pipe({
    name: 'fiTerminationPeriodTypeName',
    standalone: false,
})
export class TerminationPeriodTypeNamePipe implements PipeTransform {
    constructor(private appText: AppTextService) {}

    transform(value: any, args?: any): any {
        return fiTerminationPeriodTypeName(value, this.appText);
    }
}
